import { render, staticRenderFns } from "./msgOrderAsk.vue?vue&type=template&id=c658789c&scoped=true&"
import script from "./msgOrderAsk.vue?vue&type=script&lang=js&"
export * from "./msgOrderAsk.vue?vue&type=script&lang=js&"
import style0 from "./msgOrderAsk.vue?vue&type=style&index=0&id=c658789c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c658789c",
  null
  
)

export default component.exports